module.exports = __webpack_public_path__ + "static/media/fb.72948ac7.svg";